<template>
<v-layout wrap class="phone">
<!--
	 <v-flex md1 >
		<v-select class="nopadding" v-model="selectcountry"  :items="phcountries"   item-text="name" item-value="name" return-object  hide-details>
			  <template slot="selection" slot-scope="{ item, selected }" style="border-style:none;"> 
				<div :class="'flag flag-' + item.code" style="font-size: 20px;"></div>
			  </template>
			  <template slot="item" slot-scope="data"  >
				<template v-if="typeof data.item !== 'object'">
				  <v-list-tile-content v-text="data.item"></v-list-tile-content>
				</template>
				<template v-else class="pa-0">
				  <v-list-tile-avatar  @click="selectCountry(data.item)">
					<div :class="'flag flag-' +data.item.code" style="font-size: 20px;"></div>
				  </v-list-tile-avatar>
				  <v-list-tile-content class="pa-0" @click="selectCountry(data.item)">
					<v-list-tile-title>{{ data.item.name }} <span color="#0000008a">(+{{ data.item.cc }})</span></v-list-tile-title>
				  </v-list-tile-content>
				</template>
			  </template>
		</v-select>
	</v-flex>
	 <v-flex md11>
		<v-text-field name="phonenumber" label="Enter Phonenumber" id="phonenumber" type="text"  v-model="phonenumber" @input="onInput" required ></v-text-field>
	 </v-flex>
-->
<!--
{{ phdefault }} 
next->
{{ value }}
-->
<!--
{{ value.phone }}  @input="onInput($event,'ph')" :ref="`ph${index}`"  :value="value.phone"
{{ value.country }} @change="onInput($event,'cc')" :ref="`cc${index}`" :value="value.country" 
-->
<v-flex md1 ma-0>
	<v-select full-width flat class="nopadding" :id="id"  v-model="phdefault.country"  :items="phcountries" item-text="name" item-value="name" return-object  hide-details @change="onInput($event,'cc')" >
		  <template slot="selection" slot-scope="{ item, selected }" style="border-style:none; margin-left:0px !important; "> 														
			<div :class="'flag flag-' + item.code" style="font-size: 20px;  margin-left:0px !important;  margin-top: -25px;"></div>
		  </template>
		  <template slot="item" slot-scope="data"  >
			<template v-if="typeof data.item !== 'object'">
			  <v-list-tile-content v-text="data.item"></v-list-tile-content>
			</template>
			<template v-else class="pa-0">
			  <v-list-tile-avatar >
				<div :class="'flag flag-' +data.item.code" style="font-size: 20px;"></div>
			  </v-list-tile-avatar>
			  <v-list-tile-content class="pa-0" >
				<v-list-tile-title>{{ data.item.name }} <span color="#0000008a">(+{{ data.item.cc }})</span></v-list-tile-title>
			  </v-list-tile-content>
			</template>
		  </template>
	</v-select>
</v-flex>
 <v-flex md11>
	<v-text-field class="pl-3 ml-3 "  name="phonenumber" v-model="phdefault.phone" type="text" :rules="phoneRules" :label="label" :solo="solo"  required @input="onInput($event,'ph')" ></v-text-field>
 </v-flex>
 
</v-layout>
</template>

<script>
var PhoneNumber = '';
var PhoneCountry = { name: 'United States', cc: '1', code: 'us' };
import json from '../../country.json'

export default {
  props: {
	  label: {
		  type: String,
		  default(){
			return 'Phone'
		  }
	  },
	  id: {
		  type: String,
		  default(){
			return 'phonenumber'
		  }
	  },
	  index: {
		  type: Number,
		  default(){
			return 0
		  }
	  },
	  solo: {
		  type: Boolean,
		  default(){
			return false
		  }
	  },
	  value: {
		  type: [Array, Object, String],
		  default(){
			return { pref:false,phone:'',country:{ name: 'United States', cc: '1', code: 'us' },label:'Home',privatenumberSid:'' };
		  }
	  },
  },
  data () {
    return {
		
		//phdefault: {pref:false,phone:'',country:{"name":"India","cc":"91","code":"in"},label:'Home',privatenumberSid:''},		
		phcountries: json,
		phcountries2: [
				  {"name": "United States","code": "us","cc": 1},
				  {"name": "Canada","code": "ca","cc": 1},
				  {"name": "India","code": "in","cc": 91}
				  ],		
	    country: 'United States',
	    countryCode: '1',
		countryCodeimg: 'us',
		phoneRules: [
			v => !!v || 'Phone number is required',
			v => /^([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}$/.test(v) || /^\+\d{1,3}[- ]\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(v) || /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(v) || 'Phone number must be valid'
			//v => /^([0|\+[0-9]{1,5})?([5-9][0-9]{9})$/.test(v) || 'Phone number must be valid'
		],
    }
  },
  beforeCreate: function () { 
  },created: function () { 
	  
  },mounted() {  
	  var vm = this;	
	  PhoneNumber = vm.value.phone
	  PhoneCountry = vm.value.country;
  },
  computed: {
	  phdefault: {
			get: function () {
				  if(this.value.phone !== undefined && this.value.phone  !== ''){					  
					  return this.$store.state.Defaultphonelists = this.value;					  
				  }else{
					   return this.$store.state.Defaultphonelists;
				  }
			},
			set: function (newValue) {
				this.$store.state.Defaultphonelists = newValue
			}
	  }
  },
  methods: {
    // Handle country code selection
	onInput(val,type) {
		
		
		this.$emit('input', this.phdefault ) 
		
		//console.log('cc this.$refs',this.$refs['cc0'])
		//console.log('ph this.$refs',this.$refs['ph0'].isValid)
		//console.log('ph value this.$refs',this.$refs['ph0'])
		/*console.log('cc'+PhoneCountry)
		console.log('PH'+PhoneNumber)
		if(type == 'cc'){
			PhoneCountry = val
		}else{
			PhoneNumber = val			
		}
		//console.log('PH val type', type)		
		//this.$emit('input', { number:this.phonenumber , isValid: /^([0|\+[0-9]{1,5})?([5-9][0-9]{9})$/.test(this.phonenumber) , country: this.selectcountry })		
		this.$emit('input', { number:PhoneNumber , isValid: /^([0|\+[0-9]{1,5})?([5-9][0-9]{9})$/.test(PhoneNumber) , country: PhoneCountry })	*/
			
	}
  },
  watch: {
  }
}
</script>
<style>
.noborder >.v-input__slot:before {
    border-style: none;
    border-width: thin 0 0;
}
.nopadding .phone .v-list__tile{
	height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Includes/Countryphoneselect.vue